module.exports = require("./dist/supports-input-formatting");
